// Slug "parlanti" per le URL delle schede (SEO): nome struttura + nome scheda + id.
// L'id resta in coda così il lookup resta affidabile anche se il nome cambia.

export function slugify(str) {
  return String(str || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // rimuove gli accenti
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // tutto ciò che non è alfanumerico → trattino
    .replace(/^-+|-+$/g, '') // niente trattini iniziali/finali
    .slice(0, 80);
}

// Percorso della pagina scheda: /servizio/<provider-slug>/<scheda-slug>/.
// La "/" finale è voluta: a quell'URL Render serve la pagina statica con i meta
// per l'anteprima dei link (scripts/og-pages.js); senza, serve la shell generica.
// Fallback al vecchio formato (slug-id) se gli slug non sono disponibili.
export function servizioPath(servizio) {
  if (!servizio) return '/cerca';
  if (servizio.provider_slug && servizio.scheda_slug) {
    return `/servizio/${servizio.provider_slug}/${servizio.scheda_slug}/`;
  }
  if (servizio.id == null) return '/cerca';
  const slug = slugify([servizio.nome_attivita, servizio.nome].filter(Boolean).join(' '));
  return slug ? `/servizio/${slug}-${servizio.id}` : `/servizio/${servizio.id}`;
}

// Percorso pulito della pagina fornitore: /provider/<slug> (la numerazione è
// solo per i duplicati, gestita lato server). Fallback all'id se manca lo slug.
export function providerPath(provider) {
  if (!provider) return '/cerca';
  const slug = provider.slug || provider.provider_slug;
  if (slug) return `/provider/${slug}`;
  if (provider.id != null) return `/provider/${provider.id}`;
  return '/cerca';
}

// Estrae l'id numerico in coda allo slug (es. "sala-aurora-test-1" → "1").
export function idFromSlug(slug) {
  const last = String(slug || '').split('-').pop();
  return /^\d+$/.test(last) ? last : String(slug || '');
}
